import styled, { css } from "styled-components";
import {
  getBackgroundColor,
  getColor
} from "../../../../../ui/_themes/helpers";

export const KeypadWrapperStyles = css`
  min-height: 4.1em;
  pointer-events: all;
  position: relative;
  display: ${props => (props.hidden ? "none" : "flex")};
  white-space: nowrap;
  background: ${getBackgroundColor("keypad")};
  user-select: none;
`;

export const KeypadWrapper: any = styled.div`
  ${KeypadWrapperStyles};

  > section {
    display: flex;
    color: ${getColor("displays")};
    align-self: stretch;
  }

  /* Buttons in the left */
  > section:nth-of-type(1) {
    flex: 0 0 5em;
    justify-content: flex-start;

    margin-left: 0.9em;

    > div {
      display: flex;
      justify-content: center;

      &:first-child {
        margin-right: 0.8em;
      }
    }
  }

  /* Buttons in the right */
  > section:nth-of-type(5) {
    flex: 0 0 5em;
    justify-content: flex-end;

    margin-right: 0.9em;

    > div {
      display: flex;
      justify-content: center;

      &:last-child {
        margin-left: 0.8em;
      }

      > a {
        margin: 0;
      }
    }
  }

  /* Paytable button, Bet display, Bet button and FreeRounds display */
  > section:nth-of-type(2) {
    flex: 1 1 100%;
    justify-content: center;
    overflow: hidden;

    > div {
      margin-left: 0.3em;
      margin-right: 0.3em;
    }

    /* Paytable button, Bet button */
    > div:nth-of-type(1),
    > div:nth-of-type(3) {
      align-self: center;
    }

    /* Bet display */
    > div:nth-of-type(2) {
      flex: 0 0 5em;

      align-items: center;
    }

    /* FreeRound display */
    > div:nth-of-type(4) {
      flex: 0 0 5em;

      align-items: center;
    }
  }

  /* Other displays */
  > section:nth-of-type(4) {
    flex: 1 1 100%;
    justify-content: center;
    overflow: hidden;

    > div {
      flex: 1 1 100%;
      overflow: hidden;
      margin-left: 0.3em;
      margin-right: 0.3em;

      align-items: flex-end;
    }
  }

  /* Main buttons: Autoplay, Spin, Quickspin */
  > section:nth-of-type(3) {
    flex: 0 0 10em;
    display: flex;
    justify-content: center;

    > div {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 100%;
      height: 100%;

      background: transparent;

      &[data-show-butterfly="true"] {
        border-radius: 999px;
        background: ${getBackgroundColor("butterfly")};
      }

      > div:nth-of-type(2) {
        display: flex;
        margin: 0 0.5em;
      }
    }
  }
`;

KeypadWrapper.displayName = "KeypadWrapper";

export const SoundButtonWrapper: any = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
  > a {
    z-index: 2;
    width: 2.1em;
    height: 2.1em;
  }
`;

SoundButtonWrapper.displayName = "SoundButtonWrapper";
